import type {
  IAuthStore,
  IRootStore,
  ISubscriptionStore,
  IWorkspaceStore,
} from "@workspace/types";
import { inject } from "inversify";
import { ServiceID } from "./symbols";

export class RootStore implements IRootStore {
  constructor(
    @inject(ServiceID.WorkspaceStore) readonly workspace: IWorkspaceStore,
    @inject(ServiceID.AuthStore) readonly auth: IAuthStore,
    @inject(ServiceID.SubscriptionStore)
    readonly subscription: ISubscriptionStore,
  ) { }
}

Object.getPrototypeOf(RootStore.prototype).constructor = Object;
